import React from "react";
import { Card, CardBody, CardHeader, Row, Col, Label } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from "react-router-dom";
import { BETA_ROLES } from '../utils/constants/betaRoles';

function BetaRoleCards() {
  return (
    <Row className="g-4">
      {BETA_ROLES.map((role) => (
        <Col key={role.id} xs="12" md="6" xl="3">
          <Card className="panel-card shadow-xs rounded-3 h-100 d-flex flex-column">
            {/* HEADER */}
            <CardHeader className="surface-elevated rounded-top-3 border-0 lh-1">
              <h3 className="h5 text-light mb-0 sfb-subtitle bangers-regular">
                {role.title}
              </h3>

              {role.subtitle && (
                <span className="small text-primary-orange mb-0 lh-sm sfb-subtitle">
                  {role.subtitle}
                </span>
              )}
            </CardHeader>

            {/* BODY */}
            <CardBody className="panel-card-body d-flex flex-column px-3 py-2">

              {/* INTRO */}
              {role?.positioning?.shortIntro && (
                <p className="small text-secondary">
                  {role.positioning.shortIntro}
                </p>
              )}

              {/* HIGHLIGHTS */}
              <p className="px-3 py-2 mb-0 badge surface-elevated bg-secondary shadow-xs border-top border-bottom rounded-0 border-end-0 border-start-0 border-primary-orange-subtle">
                {`${role.limits.officialCap} Official Spots`}
              </p>

              {/* EXPECTATIONS */}
              {role?.cardMeta?.expectations?.length > 0 && (
                <div className="d-flex flex-column flex-fill mt-3 mb-2 p-3 surface-elevated shadow-xs rounded-3">
                  <p className="h6 text-uppercase text-light fw-bold text-center">
                    Key Expectations
                  </p>

                  <Row className="flex-fill">
                    {role.cardMeta.expectations.map(({ key, label, icon }) => (
                      <Col xs="6" sm="3" md="6" lg="3" xl="6" key={`expectation-${key}`}>
                        <div className="d-flex flex-column align-items-center gap-2 py-2 small text-light">
                          <FontAwesomeIcon icon={icon} size="xl" className="text-primary-orange" />
                          <Label className="text-center lh-sm px-2">{label}</Label>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              )}

              {/* CTA */}
              <div className="text-center">
                <Link
                  to={`/beta-roles?roleId=${role.id}`}
                  color="primary"
                  className="btn btn-link link-offset-2 role-card-details-link"
                >
                  View Details
                </Link>
              </div>

            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

export default BetaRoleCards;
